export const INPUT_TYPE_TEXTFIELD = 'INPUT_TYPE_TEXTFIELD'
export const INPUT_TYPE_PASSWORD = 'INPUT_TYPE_PASSWORD'
export const INPUT_TYPE_TEXTAREA = 'INPUT_TYPE_TEXTAREA'
export const INPUT_TYPE_RADIO = 'INPUT_TYPE_RADIO'
export const INPUT_TYPE_CHECKBOX = 'INPUT_TYPE_CHECKBOX'
